import { Typography } from '@material-tailwind/react';
import React from 'react';

export default function Footer() {
  // const [email, setEmail] = React.useState<string>('');

  // const handleEmailChange = (e: React.ChangeEvent<{ value: string }>) => {
  //   e.preventDefault();
  //   setEmail(e.currentTarget.value);
  // };

  const LINKS = [
    {
      title: 'Company',
      items: [
        { link: 'https://powerlabstech.com/company/who-we-are', text: 'Who we are' },
        { link: 'https://powerlabstech.com/company/our-mission', text: 'Our mission' },
        { link: 'https://powerlabstech.com/articles-and-research', text: 'Articles and research' },
        { link: 'https://powerlabstech.com/community', text: 'Community' },
      ],
    },
    {
      title: 'Products',
      items: [
        { link: 'https://pai.powerlabstech.com', text: 'Pai' },
        { link: 'https://pai.powerlabstech.com/enterprise', text: 'Pai Enterprise' },
      ], // add Plug Bag here later
    },
    {
      title: 'Social',
      items: [
        { link: 'https://www.instagram.com/powerlabshq/', text: 'Instagram' },
        { link: 'https://twitter.com/Powerlabshq', text: 'Twitter' },
        // { link: "/", text: "Facebook" },
        {
          link: 'https://www.linkedin.com/company/powerlabstech/',
          text: 'LinkedIn',
        },
      ],
    },
    {
      title: 'Support',
      items: [{ link: 'https://powerlabstech.com/contact', text: 'Contact' }],
    },
  ];
  return (
    <footer className="px-4 lg:px-20 pt-10 pb-20">
      {/* <div className="border-t border-t-[#FAFAFA]/[12%] pt-8 flex flex-col gap-8 lg:justify-between lg:flex-row py-8 lg:items-center">
        <div>
          <Typography
            variant="small"
            className="mb-4 uppercase font-semibold w-full text-default tracking-wide"
          >
            Subscribe to our newsletter
          </Typography>
          <p className="text-body-text">
            A monthly digest of the latest news, articles, and resources.
          </p>
        </div>
        <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
          <div className="bg-[#0F1015] h-full ">
            <Input
              autoComplete="off"
              name="email"
              type="email"
              placeholder="Email address"
              className="!border !border-default/[12%] px-[14px] py-2.5 rounded-lg text-default placeholder:opacity-[64%] focus:!border-[#1570EF] text-base bg-[#0F1015] h-full"
              labelProps={{
                className: "hidden",
              }}
              containerProps={{
                className: "!min-h-full lg:min-w-[410px]",
              }}
            />
          </div>
          <button
            type="submit"
            className="lg:text-base normal-case rounded px-4 py-2 bg-[#1570EF] text-default max-h-10 font-semibold"
          >
            Subscribe
          </button>
        </div>
      </div> */}
      {/* <div className="md:flex justify-between text-secondary mb-4">
        <div className="text-left mb-5 md:mb-0">
          <h3 className="text-xl  text-secondary font-bold">Subscribe to our newsletter</h3>
          <p className="text-sm text-gray-500">
            A monthly digest of the latest news, articles, and resources.
          </p>
        </div>

        <div className="flex items-center">
          <Input
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            crossOrigin={undefined}
            value={email}
            label="Email"
            variant="outlined"
            onChange={handleEmailChange}
            placeholder="hello@powerlabstech.com"
            className="text-secondary"
          />
          <Button
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            className="bg-primary text-secondary ml-4"
          >
            Subscribe
          </Button>
        </div>
      </div> */}
      <div className="border-t border-t-[#FAFAFA]/[12%] grid grid-cols-1 justify-between gap-4 lg:grid-cols-[400px_1fr] gap-y-10 py-10">
        <img src="/images/powerlabsLogo.svg" alt="logo" height={28} width={118} />
        <div className="grid-cols-2 grid lg:grid-cols-4 justify-between gap-4 gap-y-10 lg:gap-x-8">
          {LINKS.map(({ title, items }) => (
            <ul key={title}>
              <Typography
                variant="small"
                color="white"
                className="mb-4 opacity-[64%] uppercase font-semibold w-full"
                placeholder={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              >
                {title}
              </Typography>
              {items.map(({ link, text }) => (
                <li key={link}>
                  <Typography
                    as="a"
                    href={link}
                    color="white"
                    className="py-1.5 font-light opacity-90"
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  >
                    {text}
                  </Typography>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
      <div className="border-t text-secondary border-t-[#FAFAFA]/[12%] pt-8 flex flex-col gap-8 lg:justify-between lg:flex-row lg:pb-16 opacity-[64%] text-body-text">
        <div>
          <p>&copy; {new Date().getFullYear()} PowerLabs Technologies, Inc. All rights reserved.</p>
        </div>
        <div className="flex gap-4">
          <p>Terms</p>
          <p>Privacy</p>
          <p>Cookies</p>
        </div>
      </div>
    </footer>
  );
}
